module.exports = __webpack_public_path__ + "static/img/yb.23d7410.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yb.png
// module id = fRBm
// module chunks = 1